<!-- header -->
<header class="sigma_header header-4 can-sticky header-absolute">
    <!-- Middle Header Start -->
    <div class="sigma_header-middle">
        <div class="container">
            <nav class="navbar">
                <!-- Logo Start -->
                <div class="sigma_logo-wrapper">
                    <a class="navbar-brand  m-auto" href="index.html" target="_blank">
                        <img src="../../../../assets/images/logo.png" alt="logo">
                    </a>
                </div>
                <!-- Logo End -->
                <div class="contact-info">
                    <ul class="sigma_header-top-links">
                        <li class="menu-item"> <i class="fa fa-phone"></i> 01972:286354, 8219167010, 8988506146,
                            01972-286354
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <!-- Middle Header End -->
</header>
<!-- partial -->


<!-- subheader -->
<!-- <div class="banner-wrap">
    <div class="sigma_subheader dark-overlay dark-overlay-2" style="background-image: url(../../../../assets/images/subheader.jpg)">
        <div class="container">
            <div class="sigma_subheader-inner">
                <div class="sigma_subheader-text">
                    <h1>Online Accomodation </h1>
                </div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a class="btn-link" href="index.html" target="_blank">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Online Accomodation </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div> -->